export default "__VITE_ASSET__D69IOusY__"